import React from "react";
import './Button.css'

const Button = (props) => {
    return (
        <button disabled>NDA</button>
    )
};

export default Button;